module.exports = __webpack_public_path__ + "static/media/auditoriumP.37abdc9e.jpg";